module.exports = __webpack_public_path__ + "media/pricing/cross-sell-banner-0cb7b5e7.png";